// extracted by extract-css-chunks-webpack-plugin
module.exports = {"car_city":"car_city-2g4V6f8Z"};